import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { QualificationItem } from '../types';
import { StatusIcon } from '../StatusIcon';

const HTTP_LINK_REGEX = /^https?:\/\//i;

const isHttpLink = (url?: string): url is string => !!url && HTTP_LINK_REGEX.test(url);

const QualificationItemComponent: React.FC<{ item: QualificationItem }> = ({ item }) => {
  const { t } = useTranslation();
  
  const getSubItemStatusText = (sub: QualificationItem) => {
    console.log('Sub Item Status of' + sub.title + ':', sub.status);
    console.log('Sub Item Date of' + sub.title + ':', sub.date);
    if (sub.date) return sub.date;
    if (sub.status === 'invalid') return t('passportPage.labels.notValid');
    if (sub.status === 'notqualified') return t('passportPage.labels.incomplete');
    if (sub.status === 'notvalid') return t('passportPage.labels.notApplicable');
    return t('passportPage.labels.valid');
  };
  
  return (
  <>
    {/* Main Item */}
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{
        px: 1.5,
        py: 0.5,
        backgroundColor: '#ffffff',
        mb: '0px',
        border: '1px solid #f0f0f0',
        borderRadius: '4px',
      }}
    >
      <Typography
        fontSize="0.875rem"
        sx={{
          flex: 1,
          marginRight: 2,
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {isHttpLink(item.learningLink) ? (
          // New tab: learning links are often Workday pages that ask for a login
          <Link href={item.learningLink} target="_blank" rel="noopener noreferrer">
            {item.title}
          </Link>
        ) : (
          item.title
        )}
      </Typography>
      <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
        <StatusIcon status={item.status} />
        <Typography
          fontSize="0.875rem"
          color={item.status === 'invalid' ? 'red' : 'inherit'}
          sx={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
        >
          {getSubItemStatusText(item)}
        </Typography>
      </Box>
    </Box>

    {/* Subitems if present */}
    {item.subItems && item.subItems.length > 0 && item.subItems.map((sub, index) => (
      <Box
        key={index}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: 2,
          py: 0.5,
          borderBottom: '1px solid #eee',
          backgroundColor: '#FAFAFA',
          ml: 4,
          border: '1px solid #E0E0E0',
          mb: '2px'
        }}
      >
        <Typography fontSize="0.825rem">{sub.title}</Typography>
        <Box display="flex" alignItems="center">
          <StatusIcon status={sub.status} />
          <Typography
            fontSize="0.825rem"
            color={sub.status === 'invalid' ? 'red' : 'inherit'}
          >
            {getSubItemStatusText(sub)}
          </Typography>
        </Box>
      </Box>
    ))}
  </>
);
}

export default QualificationItemComponent;
